import Vue from 'vue';

export default {
  methods: {
    alertError(params = {}) {
      return Vue.notify({
        group: 'app',
        type: 'error',
        text: params['text'] || this.$dt('global.notify_error_default_text'),
        title: params['title'] || this.$dt('global.notify_error_default_title'),
        speed: 1000,
      });
    },
    alertSuccess(params = {}) {
      return Vue.notify({
        group: 'app',
        type: 'success',
        text: params['text'] || this.$t('global.notify_success_default_text'),
        title: params['title'] || this.$t('global.notify_success_default_title'),
        speed: 1000
      });
    },
    alertInfo(params = {}) {
      return Vue.notify({
        group: 'app',
        type: 'warn',
        text: params['text'] || this.$t('global.notify_info_default_text'),
        title: params['title'] || this.$t('global.notify_info_default_title'),
        speed: 1000
      });
    },
  }
};
